import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer>
      <br />
      <div className="container-fluid bg-dark text-white">
        <div className="row">
          {/* Sección de la empresa */}
          <div className="col-md-3 py-3">
            <div className="h6">Presto Enterprise</div>
            <hr />
            <p>
              Nos especializamos en la venta de piezas y componentes para diversos sectores, 
              incluyendo eléctricos, agrícolas, electrónicos y mecánicos. Ofrecemos soluciones 
              de alta calidad para vehículos, equipos industriales y más, garantizando siempre 
              eficiencia y confiabilidad en cada producto.
            </p>
          </div>

          {/* Sección de productos - Primera columna */}
          <div className="col-md-3 py-3">
            <div className="h6">Categorías</div>
            <hr />
            <ul className="list-group list-group-flush">
              <li className="list-group-item bg-dark text-white border-light">
                <Link to="/category?categoryId=1&categoryName=ELECTRICAS" className="text-decoration-none text-white stretched-link">
                  Eléctricas
                </Link>
              </li>
              <li className="list-group-item bg-dark text-white border-light">
                <Link to="/category?categoryId=2&categoryName=AGRICOLAS" className="text-decoration-none text-white stretched-link">
                  Agrícolas
                </Link>
              </li>
              <li className="list-group-item bg-dark text-white border-light">
                <Link to="/category?categoryId=3&categoryName=BRASILEÑAS" className="text-decoration-none text-white stretched-link">
                  Brasileñas
                </Link>
              </li>
              <li className="list-group-item bg-dark text-white border-light">
                <Link to="/category?categoryId=4&categoryName=CARROCERIA" className="text-decoration-none text-white stretched-link">
                  Carrocería
                </Link>
              </li>
            </ul>
          </div>

          {/* Sección de productos - Segunda columna */}
          <div className="col-md-3 py-3">
            <div className="h6">Categorías</div>
            <hr />
            <ul className="list-group list-group-flush">
              <li className="list-group-item bg-dark text-white border-light">
                <Link to="/category?categoryId=5&categoryName=ELECTRONICAS" className="text-decoration-none text-white stretched-link">
                  Electrónicas
                </Link>
              </li>
              <li className="list-group-item bg-dark text-white border-light">
                <Link to="/category?categoryId=6&categoryName=INYECCION" className="text-decoration-none text-white stretched-link">
                  Inyección
                </Link>
              </li>
              <li className="list-group-item bg-dark text-white border-light">
                <Link to="/category?categoryId=7&categoryName=MECANICAS" className="text-decoration-none text-white stretched-link">
                  Mecánicas
                </Link>
              </li>
              <li className="list-group-item bg-dark text-white border-light">
                <Link to="/category?categoryId=8&categoryName=MISELANEOS" className="text-decoration-none text-white stretched-link">
                  Misceláneos
                </Link>
              </li>
            </ul>
          </div>

          {/* Sección de dirección */}
          <div className="col-md-3 py-3">
            <div className="h6">Dirección:</div>
            <hr />
            <address>
              <strong>Presto Enterprise</strong>
              <br />
              Av. México 13, Santo Domingo
              <br />
              <abbr title="Phone">T:</abbr> (809) 564-1967
            </address>
            <hr />
            <i className="bi bi-telephone"></i> (809) 564-1967
            <br />
            <i className="bi bi-envelope"></i> info@email.com
          </div>
        </div>
      </div>

      {/* Sección de derechos reservados */}
      <div className="container-fluid bg-secondary text-white text-center">
        <div className="row">
          <div className="col-md-12 py-2">
            © 2024-{new Date().getFullYear()} Presto Enterprise
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
